<script setup lang="ts">
import { VContentGridItem, VMapFull, VMapMarker, VMapZoom, VPreloader } from '@/shared/ui'
import {
  YMap,
  YMapControls,
  YMapDefaultFeaturesLayer,
  YMapDefaultSchemeLayer,
  YMapMarker,
} from '@/shared/lib'
import useModel from './../model/model'
import './assets/style.scss'
import { useRoute } from 'vue-router'
import { computed } from 'vue'
import { ObjectTypesMap } from '@/entities/Object'

defineOptions({ name: 'map' })

const { center, zoom, full, marker, loadData } = useModel()
const route = useRoute()

/**
 * Получаем ссылку для установки координат
 */
const setCoordsLink = computed(() => {
  const params = route.params
  return `/objects/${params.type}/${params.object_id}/admin`
})

/**
 * Получаем иконку объекта по его типу
 */
const markerType = computed(() => {
  return ObjectTypesMap[route.params.type as string].icon
})

const { isFetching } = loadData()
</script>

<template>
  <VContentGridItem :title="$t('itf.map')">
    <VPreloader v-if="isFetching" :wrapper-height="400" />
    <YMap
      v-else
      class="position_relative"
      :class="full ? 'position_page-full' : ''"
      :location="{ center, zoom }"
      :style="{ height: '400px' }"
    >
      <YMapDefaultSchemeLayer />
      <YMapDefaultFeaturesLayer />
      <YMapControls position="top left">
        <VMapZoom v-model="zoom" />

        <VMapFull v-model="full" />
      </YMapControls>

      <div v-if="!marker.longitude || !marker.latitude" class="w-object-map__empty">
        <RouterLink :to="setCoordsLink">
          <VBtn>{{ $t('itf.set_coordinates') }}</VBtn>
        </RouterLink>
      </div>

      <YMapMarker v-else :coordinates="[marker.longitude, marker.latitude]">
        <VMapMarker :type="markerType" :status="0" />
      </YMapMarker>
    </YMap>
  </VContentGridItem>
</template>
